import { Search } from 'lucide-react';
import { Input } from 'alurkerja-ui';

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export default function SearchBar({
  value,
  onChange,
  placeholder = 'Search...',
  className = '',
}: SearchBarProps) {
  return (
    <div className={`${className}`}>
      <Input
        value={value}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
        placeholder={placeholder}
        name="search"
        size="sm"
        rounded="lg"
        prefix={<Search size={16} />}
      />
    </div>
  );
}
